import React from "react";
import { useTranslation } from "react-i18next";

const LICENSE_OPTIONS = {
  DEVELOPER: "developer",
  OWN: "own",
};

const Step2LicenseChoice = ({ answers, updateAnswers }) => {
  const { t } = useTranslation();

  const handleSelect = (value) => {
    updateAnswers({ licenseChoice: value });
  };

  return (
    <div className="onboarding-step onboarding-step--license">
      <h2 className="onboarding-step__title">
        {t("homeModalWelcome.step2.title")}
      </h2>
      <p className="onboarding-step__description">
        {t("homeModalWelcome.step2.description")}
      </p>

      <div className="onboarding-radio-cards onboarding-radio-cards--vertical">
        <button
          type="button"
          className={`onboarding-radio-card ${
            answers.licenseChoice === LICENSE_OPTIONS.DEVELOPER ? "is-selected" : ""
          }`}
          onClick={() => handleSelect(LICENSE_OPTIONS.DEVELOPER)}
        >
          <div className="onboarding-radio-card__header">
            <span className="onboarding-radio-card__title">
              {t("homeModalWelcome.step2.optionDeveloper.title")}
            </span>
            <span className="onboarding-radio-card__badge onboarding-radio-card__badge--free">
              {t("homeModalWelcome.step2.optionDeveloper.badge")}
            </span>
          </div>
          <span className="onboarding-radio-card__description">
            {t("homeModalWelcome.step2.optionDeveloper.description")}
          </span>
        </button>

        <button
          type="button"
          className={`onboarding-radio-card ${
            answers.licenseChoice === LICENSE_OPTIONS.OWN ? "is-selected" : ""
          }`}
          onClick={() => handleSelect(LICENSE_OPTIONS.OWN)}
        >
          <div className="onboarding-radio-card__header">
            <span className="onboarding-radio-card__title">
              {t("homeModalWelcome.step2.optionOwn.title")}
            </span>
            <span className="onboarding-radio-card__badge onboarding-radio-card__badge--paid">
              {t("homeModalWelcome.step2.optionOwn.badge")}
            </span>
          </div>
          <span className="onboarding-radio-card__description">
            {t("homeModalWelcome.step2.optionOwn.description")}
          </span>
        </button>
      </div>
    </div>
  );
};

Step2LicenseChoice.canAdvance = (answers) => {
  return (
    answers.licenseChoice === LICENSE_OPTIONS.DEVELOPER ||
    answers.licenseChoice === LICENSE_OPTIONS.OWN
  );
};

export { LICENSE_OPTIONS };
export default Step2LicenseChoice;
